var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkbox" }, [
    _c(
      "div",
      { staticClass: "togglebutton" },
      [
        _c("toggle-button", {
          attrs: {
            sync: true,
            color: _vm.color
              ? _vm.color
              : { checked: "#07da70", unchecked: "#cccccc" },
            disabled: _vm.iniDisabled,
          },
          on: { input: _vm.onChange },
          model: {
            value: _vm.selected,
            callback: function ($$v) {
              _vm.selected = $$v
            },
            expression: "selected",
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "control-label m-b-0" }, [
          _vm._v(_vm._s(_vm.label)),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }